<template>
	<el-row class="points-show">
		<el-col :span="23">
			考试管理
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>试卷名称：</div>
					<el-input size="mini" placeholder="试卷名称" v-model="testpaperName" clearable />
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>试卷状态：</div>
					<el-select v-model="status" size="mini" clearable placeholder="请选择">
						<el-option v-for="item in testpaperStatus" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<el-button type="primary" size="mini" @click="handleSizeChange()">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-plus" @click="openChapterDrawer()">增加</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<!-- 数据列表 -->
			<el-table :data="testpaperData" style="width: 100%" :height="tableHeight">
				<el-table-column prop="testpaperId" label="试卷id" width="65"> </el-table-column>
				<el-table-column prop="testpaperName" label="试卷标题" width="180"> </el-table-column>
				<el-table-column prop="courseName" label="关联课程"> </el-table-column>
				<el-table-column prop="totalPassfraction" label="试卷总分"> </el-table-column>
				<el-table-column prop="createTime" label="创建日期"> </el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-switch slot="reference" v-model="testpaperData[scope.$index].status == 0"
							active-color="#13ce66" inactive-color="var(--grey)" active-text="启用" inactive-text="停用"
							@change="changesale(testpaperData[scope.$index].testpaperName,testpaperData[scope.$index].testpaperId, testpaperData[scope.$index].status)" />
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" plain type="primary"
							@click="openChapterDrawer(testpaperData[scope.$index])">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>
		<el-col :span="24">
			<el-drawer title="" :visible.sync="testpaperDrawer" direction="btt" :before-close="closeTestpaperDrawer"
				size="93%">
				<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm"
					style="height:100%">
					<el-row :gutter="20">
						<el-col :span="16" :offset="4">
							<el-col :span="8">
								<el-form-item label="试卷标题" prop="testpaperName">
									<el-input size="mini" v-model="form.testpaperName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="试卷总分" prop="totalPassfraction">
									<el-input size="mini" v-model="form.totalPassfraction"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="及格分数" prop="testpaperPassfraction">
									<el-input size="mini" v-model="form.testpaperPassfraction"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="绑定课程" prop="testpaperPassfraction">
									<el-select size="mini" v-model="form.courseId" filterable placeholder="请选择">
										<el-option v-for="item in options" :key="item.courseId" :label="item.courseName"
											:value="item.courseId">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-col>
						<el-col :span="16" :offset="4">
							<el-button size="mini" type="primary" icon="el-icon-plus" @click="addQuestions(0)">选择
							</el-button>
							<el-button size="mini" type="primary" icon="el-icon-plus" @click="addQuestions(1)">填空
							</el-button>
							<el-col :span="10">当前共{{questions.length}}题</el-col>
						</el-col>
					</el-row>
					<!-- 试题部分 -->
					<el-row class="ques-row">
						<el-row v-for="(item,i) in questions" :key="i">
							<el-col :span="16" :offset="4">
								<el-divider><i class="el-icon-mobile-phone"></i>第{{i+1}}题</el-divider>
							</el-col>
							<el-row>
								<el-col :span="16" :offset="4">
									<el-col :span="8">
										<el-form-item label="试题标题">
											<el-input size="mini" v-model="item.title"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="试题内容">
											<el-input size="mini" v-model="item.content"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="正确答案">
											<el-input size="mini" v-model="item.successAnswer"></el-input>
										</el-form-item>
									</el-col>
								</el-col>
								<el-col :span="16" :offset="4">
									<el-col :span="8" v-if="item.subjectType == 0"
										v-for="(option,index) in item.options" :key="index">
										<el-form-item :label="option.optionName">
											<el-input size="mini" v-model="option.optionContent"></el-input>
										</el-form-item>
									</el-col>
								</el-col>
							</el-row>
						</el-row>
					</el-row>
					<el-row>
						<el-col :span="4" :offset="10">
							<el-button type="primary" size="mini" @click="upload()">提交</el-button>
						</el-col>
					</el-row>
				</el-form>
			</el-drawer>
		</el-col>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	export default {
		data() {
			return {
				// 分页组件
				pageNum: 1,
				pageSize: 15,
				total: null,
				// table 自适应高度
				tableHeight: window.innerHeight - 300,
				// 查询用到的参数
				testpaperName: '',
				status: '',
				testpaperStatus: [{
					label: '全部',
					value: ''
				}, {
					label: '启用',
					value: '0'
				}, {
					label: '停用',
					value: '1'
				}],
				//课程数组
				options: [],
				// 试卷的数据组
				testpaperData: [],
				// 试卷编辑或增加打开
				testpaperDrawer: false,
				form: {
					testpaperId: '',
					testpaperName: '',
					totalPassfraction: '',
					testpaperPassfraction: '',
					courseId: ''
				},
				rules: {
					testpaperName: [{
							required: true,
							message: '请输入试卷名称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 15,
							message: '长度在 3 到 15 个字符',
							trigger: 'blur'
						}
					],
					totalPassfraction: [{
						required: true,
						message: '请输入试卷总分',
						trigger: 'blur'
					}],
					testpaperPassfraction: [{
						required: true,
						message: '请输入及格分数',
						trigger: 'blur'
					}],
				},
				//用来存对应的试题内容
				questions: []
			}
		},
		created() {
			this.query();
		},
		methods: {
			upload() {
				var testpaperform = this.form;
				testpaperform.subjects = this.questions;
				this.$http.post('/api/source/clrTestpaper/add', testpaperform).then(res => {
					if (res.data.status == 0) {
						this.$message.success("操作成功");
						this.query();
						this.closeTestpaperDrawer();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			// 试题的增加或修改
			addQuestions(type) {
				var ques = {
					title: '',
					content: '',
					subjectType: type,
					successAnswer: ''
				}
				if (type == 0) {
					ques.options = [{
							optionName: 'A',
							optionContent: ''
						},
						{
							optionName: 'B',
							optionContent: ''
						},
						{
							optionName: 'C',
							optionContent: ''
						},
						{
							optionName: 'D',
							optionContent: ''
						}
					]
				}
				this.questions.push(ques);
				console.log(this.questions)
			},
			// 查询试卷列表数据
			query() {
				var status = this.status;
				var testpaperName = this.testpaperName;
				this.$http.post('/api/source/clrTestpaper/listPage?pageNum=' + this.pageNum + '&pageSize=' + this
					.pageSize, {
						memberId: "",
						status: status,
						testpaperName: testpaperName
					}).then(res => {
					this.testpaperData = res.data.data.list;
					this.total = res.data.data.total;
				});
			},
			//切换试卷启停用
			changesale(courseName, id, status) {
				status = status == 0 ? 1 : 0;
				this.$http.post('/api/source/clrTestpaper/update', {
					testpaperId: id,
					status: status
				}).then(res => {
					if (res.data.status == 0) {
						var statusText = status != 0 ? '下架' : '上架';
						if (status != 0) {
							this.$message.error(courseName + "已" + statusText);
						} else {
							this.$message.success(courseName + "已" + statusText);
						}
						this.query();
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			openChapterDrawer(row) {
				this.$http.post('/api/source/clrCourse/listPage?pageNum=&pageSize=', {
					status: '0'
				}).then(res => {
					if (res.data.status == 0) {
						this.options = res.data.data.list
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
				if (row == undefined) {
					// 增加
				} else {
					// 修改
					this.$http.get('/api/source/clrTestpaper/selectOne?pk=' + row.testpaperId + '&memberId=1', {

					}).then(res => {
						if (res.data.status == 0) {
							this.form = res.data.data;
							for (var i = 0; i < res.data.data.subjects.length; i++) {
								if (res.data.data.subjects[i].options.length <= 0) {
									var optiona = {
										optionName: 'A',
										optionContent: ''
									};
									var optionb = {
										optionName: 'B',
										optionContent: ''
									};
									var optionc = {
										optionName: 'C',
										optionContent: ''
									};
									var optiond = {
										optionName: 'D',
										optionContent: ''
									};
									res.data.data.subjects[i].options.push(optiona);
									res.data.data.subjects[i].options.push(optionb);
									res.data.data.subjects[i].options.push(optionc);
									res.data.data.subjects[i].options.push(optiond);
								}
							}
							this.questions = res.data.data.subjects;
							console.log(this.form)
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
				}
				this.testpaperDrawer = true
			},
			closeTestpaperDrawer() {
				// this.resetForm('chapterForm');
				this.testpaperDrawer = false
				this.$refs['form'].resetFields();
				this.form.courseId = '';
				this.questions = [];
			},
			// 分页组件
			handleSizeChange() {
				this.pageNum = 1;
				this.query();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.query();
			},
		}
	}
</script>
<style lang="less" scoped>
	/deep/.el-input {
		height: auto;
	}
</style>
